import {ComponentType} from '@angular/cdk/portal';
import {Injectable, ViewContainerRef} from '@angular/core';
import {MatDialog} from '@angular/material/dialog';
import {Dialog} from './dialog';
import {IDialogComponent} from './iDialog.component';
import {DialogWrapperComponent} from './dialog-wrapper/dialog-wrapper.component';

export interface DialogData<R, DialogInput, T extends IDialogComponent<DialogInput, R>> {
    componentType: ComponentType<T>;
    customData: DialogInput;
    options: DialogOptions;
}

export interface DialogOptions {
    title?: string;
    height?: string;
    width?: string;
}

@Injectable({providedIn: 'root'})
export class DialogController {

    public constructor(private dialog: MatDialog) {
    }

    // viewContainerRef must be provided if you want to propagate parent component providers.
    open<R, DialogInput, T extends IDialogComponent<DialogInput, R>>(component: ComponentType<T>,
                                                                     data: DialogInput,
                                                                     options: DialogOptions,
                                                                     viewContainerRef?: ViewContainerRef): Dialog<R> {
        const height = options.height ? options.height : undefined;
        const width = options.width ? options.width : undefined;
        const dialogRef = this.dialog.open(DialogWrapperComponent, {
            autoFocus: false,
            disableClose: true,
            data: {
                customData: data,
                componentType: component,
                options,
            },
            width,
            // height,
            viewContainerRef
        });
        return new Dialog<R>(dialogRef);
    }
}
